import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=fbd9f448&scoped=true&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=fbd9f448&lang=scss&scoped=true&"
import style1 from "./TipTap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9f448",
  null
  
)

export default component.exports